import { useNavigate } from 'react-router-dom';
import { Plane, MapPin, Heart, Star, User, Calendar } from 'lucide-react';
import type { PlazaNoteListItem } from '@/types/notes.types';

interface PlazaNoteCardProps {
  note: PlazaNoteListItem;
}

export function PlazaNoteCard({ note }: PlazaNoteCardProps) {
  const navigate = useNavigate();

  const excerpt = note.content
    ? note.content.replace(/[#*\-\[\]`]/g, '').slice(0, 200) + (note.content.length > 200 ? '...' : '')
    : '';

  return (
    <div
      onClick={() => navigate(`/notes/plaza/${note.id}`)}
      className="group relative bg-white border border-gray-200 rounded-xl p-5 cursor-pointer transition-all hover:shadow-md hover:border-blue-300"
    >
      {/* 标题 */}
      <h3 className="text-base font-semibold text-gray-900 mb-2 line-clamp-1">
        {note.title}
      </h3>

      {/* 摘要 */}
      <p className="text-sm text-gray-600 line-clamp-4 mb-3 leading-relaxed">
        {excerpt || '暂无内容'}
      </p>

      {/* 关联信息 */}
      <div className="flex flex-wrap items-center gap-2 text-xs text-gray-500 mb-3">
        {note.route && (
          <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-blue-50 text-blue-600 rounded">
            <Plane className="w-3 h-3" />
            {note.route.codePair}
          </span>
        )}
        {note.airports?.map((ap) => (
          <span
            key={ap.iataCode}
            className="inline-flex items-center gap-1 px-2 py-0.5 bg-green-50 text-green-600 rounded"
          >
            <MapPin className="w-3 h-3" />
            {ap.iataCode}
          </span>
        ))}
      </div>

      {/* 底部：作者 + 点赞/收藏 + 时间 */}
      <div className="flex items-center justify-between text-xs text-gray-400">
        <div className="flex items-center gap-3">
          <span className="inline-flex items-center gap-1 text-gray-500">
            <User className="w-3 h-3" />
            {note.authorDisplay}
          </span>
          <span className="inline-flex items-center gap-1">
            <Heart className="w-3 h-3" />
            {note.likeCount}
          </span>
          <span className="inline-flex items-center gap-1">
            <Star className="w-3 h-3" />
            {note.favoriteCount}
          </span>
        </div>
        <span className="inline-flex items-center gap-1">
          <Calendar className="w-3 h-3" />
          {new Date(note.createdAt).toLocaleDateString('zh-CN')}
        </span>
      </div>
    </div>
  );
}
